import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import VueRout from 'vue-router';
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import animate from 'animate.css';
import "animate.css"
import * as format from '@/utils/format'
// 注册为全局方法
Object.keys(format).forEach(key => {
  Vue.prototype[`$${key}`] = format[key]
})

Vue.use(ElementUI);
Vue.use(VueRout);
Vue.use(animate);
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')
